import React, { useState } from 'react'
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'
import req from '@sportninja/common/api/request'

import Page from '../../components/Page'
import FormSheet from '../../components/Form/FormSheet'
import NewButton from '../../components/Page/NewButton'
import { orgForm } from '../../components/Form/form-configs'
import OrgList from './OrgList'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from 'src/state'

const Organizations = () => {
  const [orgCount, setOrgCount] = useState('')
  const [favCount, setFavCount] = useState('')
  const [refreshKey, setRefreshKey] = useState(0)

  const { me: { state: { account, me } } } = useMobxStore()

  const triggerRefresh = () => {
    setRefreshKey((key) => ++key)
  }

  const onAddOrg = async (...args) => {
    const [values] = args
    const { imageData, ...form } = values

    // Duplicate name_full since API requires it
    form.name = form.name_full
    form.can_contain_organizations = true
    form.can_contain_teams = true

    if (typeof form.is_public === 'undefined') {
      form.is_public = true
    }

    const body = JSON.stringify(form)
    const response = await req('/organizations', {
      method: 'POST',
      body,
    })

    if (imageData) {
      await req(`/organizations/${response.data.id}/image`, {
        method: 'POST',
        body: imageData,
      })
    }

    triggerRefresh()
    return response
  }

  const actions = isCanlan || me?.account_type === 1 ? [] : [
    <FormSheet
      key='add'
      Button={({ onClick }) => <NewButton onClick={onClick} />}
      form={orgForm({}, true, false, account?.subscription_type?.id !== 1)}
      label={t('Web:createOrg')}
      onSubmit={onAddOrg}
      title={t('Web:createANewOrganization')}
    />,
  ]

  const pages = [
    {
      to: `${ROUTES.ORGS.ROOT}/my`,
      text: `${t('common:organization', { count: 2 })} ${
        orgCount ? `(${orgCount})` : ''
      }`,
      component: (
        <OrgList
          key='orgs'
          slug='/users/me/organizations'
          setCount={setOrgCount}
          refreshKey={refreshKey}
        />
      ),
      actions: actions,
    },
    {
      to: `${ROUTES.ORGS.FAVOURITES}`,
      text: `${t('common:favourite', { count: 2 })} ${
        favCount ? `(${favCount})` : ''
      }`,
      component: (
        <OrgList
          key='favs'
          slug='/favorites/organizations'
          setCount={setFavCount}
        />
      ),
    },
  ]

  const BASE_ROUTE = ROUTES.ORGS.ROOT

  return (
    <Page
      baseRoute={BASE_ROUTE}
      pages={pages}
      baseTitle={t('common:organization', { count: 2 })}
      title={t('util:capitalize', {
        text: t('common:organization', { count: 2 }),
      })}
    />
  )
}

export default observer(Organizations)
